export default "/images/vendor/@coreui/icons/svg/flag/cif-gq.svg?3c93b0e9dd4767380e64455dd265be46";